import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/eosrent',
      name: 'eosrent',
      component: resolve => require(['@/pages/eos_rent'], resolve),
      children: [
        {
          path: 'order',
          name: 'order',
          component: resolve => require(['@/pages/order/home'], resolve),
          children: [
            {
              path: 'details/:id',
              name: 'details',
              component: resolve => require(['@/pages/order/details'], resolve)
            }
          ]
        },
        {
          path: 'waiting/:id',
          name: 'waiting',
          component: resolve => require(['@/pages/to_wallet_app'], resolve)
        }
      ]
    },
    {
      path: '*',
      redirect: '/eosrent'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js